module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("stateoff_social_apps_row", [["a",{"class":"","href":"","title":"","rel":"nofollow"},[["if",{"notempty":"","addattr":"target:_blank"},[],[["newTarget","notempty",true]]]],[["elementClass","class",true],["pageUrl","href",true],["title","title",true]]]]);
fox.registerTemplate("stateoff_social_appsblock", [["div",{"class":"caption"},[["textNode",{"text":"Find "}],["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" here:"}]]],["div",{"id":"find-me-container","class":"find-me-container"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/sitepage/stateoff/socialapps.tpl
// module id = 768
// module chunks = 4